import { useEffect, useState } from 'react';
import { tmdb, posterUrl } from '../lib/tmdb.js';
import staffPicks from '../config/staff-picks.json';

export default function StaffPicks({ onPosterClick }) {
  const [hydrated, setHydrated] = useState([]);

  useEffect(() => {
    let alive = true;
    Promise.all(
      staffPicks.picks.map((p) =>
        tmdb.movie(p.tmdbId).then((m) => ({ ...m, note: p.note })).catch(() => null)
      )
    ).then((list) => { if (alive) setHydrated(list.filter(Boolean)); });
    return () => { alive = false; };
  }, []);

  return (
    <section className="hb-shelf hb-shelf--staff">
      <div className="hb-shelf__sign hb-shelf__sign--staff">
        <h2 className="hb-shelf__title">Staff Picks</h2>
        <p className="hb-shelf__subtitle">Week of {staffPicks.weekOf} · curated by {staffPicks.curator}</p>
      </div>
      <div className="hb-shelf__rail">
        {hydrated.map((m) => (
          <button type="button" key={m.id} className="hb-staffpick" onClick={() => onPosterClick?.(m)}>
            <img className="hb-staffpick__art" src={posterUrl(m.poster_path)} alt="" loading="lazy" />
            <div className="hb-staffpick__note">{m.note}</div>
          </button>
        ))}
      </div>
    </section>
  );
}
